<template>
  <div class="container-fluid py-2">
    <!-- 기존 코드 -->
    <div class="row">
      <div class="col-12">
        <div class="card my-2">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-2 pb-2 d-flex align-items-center justify-content-between px-2">
              <div class="d-flex align-items-center w-100">
                <select
                  v-model="filters.department"
                  @change="fetchAttendGrid"
                  class="form-select searchInput me-2"
                  style="width: fit-content; font-size: 0.8rem;"
                >
                  <option value="">부서 선택</option>
                  <option 
                    v-for="department in departments" 
                    :key="department.id" 
                    :value="department.id"
                  >
                    {{ department.name }}
                  </option>
                </select>

                <div class="form-check ms-2">
                  <input 
                    class="custom-control-input" 
                    type="checkbox" 
                    v-model="filters.excludeTeachers"
                    @change="fetchAttendGrid"
                    id="excludeTeachersCheckbox"
                    style="margin-left: 10px;"
                  >
                  <label class="form-check-label" for="excludeTeachersCheckbox" style="font-size: 0.8rem; color: white;">
                    교사 제외
                  </label>
                </div>

                <div class="ms-auto d-flex">
                  <button 
                    class="btn btn-outline-success btn-sm me-2" 
                    @click="fetchAttendGrid"
                    style="font-size: 0.8rem;"
                  >
                    검색
                  </button>

                  <button 
                    class="btn btn-outline-success btn-sm" 
                    @click="exportToExcel"
                    :disabled="!gridData || Object.keys(gridData).length === 0"
                    style="font-size: 0.8rem;"
                  >
                    엑셀 다운로드
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-1">
            <!-- Area Chart 추가 -->
            <div class="mb-4">
              <VChart :option="areaChartOptions" style="height: 320px; width: 100%" />
            </div>
            <!-- 기존 테이블 ... -->
            <div class="table-responsive grid-container">
              <table class="table table-bordered table-hover table-sm" ref="attendanceTable">
                <thead class="sticky-header">
                  <tr>
                    <th class="text-left p-0 sticky-column name-column" style="font-size: 0.7rem;"></th>
                    <th 
                      v-for="date in dates" 
                      :key="date" 
                      class="text-center p-0 date-column"
                      style="font-size: 0.7rem;"
                    >
                      {{ formatDate(date) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="name in names" :key="name">
                    <td class="text-left p-0 sticky-column name-column" style="font-size: 0.7rem;">{{ name }}</td>
                    <td 
                      v-for="date in dates" 
                      :key="date" 
                      class="text-center p-0 grid-cell"
                      :class="{'bg-success': gridData[name] && gridData[name][date] === 'O'}"
                      style="font-size: 0.7rem;"
                    >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Popup Modal -->
    <div v-if="showPopup">
      <member-detail
        :student="selectedStudent"
        @close="closePopup"
        @save="saveStudent"
      />
    </div>
  </div>
</template>
  
<script>
import apiservice from "../services/apiservice";
import MemberDetail from "@/views/MemberDetail.vue";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import VChart from 'vue-echarts';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';

echarts.use([
  CanvasRenderer,
  LineChart,
  GridComponent,
  TooltipComponent
]);

export default {
  name: "AttendGrid",
  components: { MemberDetail, VChart },
  data() {
    return {
      teachers: [],
      currentPage: 1,
      totalPages: 1,
      filters: {
        department: "",
        excludeTeachers: true  // 기본값을 true로 설정
      },
      userData: "",
      showPopup: false,
      selectedStudent: {},
      departments: [],
      grades: [],
      names: [],
      dates: [],
      gridData: {},
      areaChartOptions: {
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: false,
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
        },
        series: [
          {
            data: [],
            type: 'line',
            areaStyle: {},
            smooth: true,
            name: '출석 인원',
            color: '#4caf50',
          }
        ],
        grid: { left: 40, right: 20, top: 30, bottom: 40 },
      },
    };
  },
  computed: {
    isSuperUser() {
      return this.$store.state.userData?.superuser === '1';
    }
  },
  methods: {
    formatDate(dateString) {
      // 날짜를 더 읽기 쉬운 형식으로 변환 (예: 2024-01-15 -> 01/15)
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    async fetchAttendGrid() {
      console.log('Fetching Attend Grid - Filters:', this.filters);
      
      if (!this.filters.department) {
        console.warn('No department selected');
        alert("부서를 선택해주세요.");
        return;
      }

      try {
        const response = await apiservice.attendweekly({
          params: this.filters
        });
        
        console.log('Attend Grid Response:', response.data);
        
        // Area Chart 데이터 처리
        if (Array.isArray(response.data)) {
          this.areaChartOptions.xAxis.data = response.data.map(item => this.formatDate(item.attenddate));
          this.areaChartOptions.series[0].data = response.data.map(item => item.count);
        } else {
          this.areaChartOptions.xAxis.data = [];
          this.areaChartOptions.series[0].data = [];
        }
      } catch (error) {
        console.error("Failed to fetch attend grid:", error);
        alert("출석 데이터를 불러오는 중 오류가 발생했습니다.");
      }
    },
    exportToExcel() {
      // 엑셀로 내보낼 데이터 준비
      const excelData = [
        // 헤더 행
        ['날짜', ...this.dates.map(date => this.formatDate(date))],
        
        // 데이터 행
        ...this.names.map(name => [
          name,
          ...this.dates.map(date => 
            this.gridData[name] && this.gridData[name][date] === 'O' ? 'O' : ''
          )
        ])
      ];

      // 워크북 생성
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '출석 현황');

      // 엑셀 파일로 저장
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // 파일 이름 생성 (부서명_출석현황_현재날짜)
      const departmentName = this.departments.find(d => d.id === this.filters.department)?.name || '부서';
      const currentDate = new Date().toISOString().split('T')[0];
      saveAs(blob, `${departmentName}_출석현황_${currentDate}.xlsx`);
    }
  },
  async created() {
    try {
      const response = await apiservice.getdeptlist();
      this.departments = response.data.data.map(department => ({
        id: department.code,
        name: department.codename
      }));

      // 사용자 권한 확인 및 부서 고정 처리
      const userData = this.$store.state.userData;
      if (userData && userData.superuser !== '1') {
        // superuser가 1이 아닌 경우 classid 값으로 department.id 고정
        this.filters.department = userData.classid;
        
        // 부서 선택 후 데이터 자동 로드
        await this.fetchAttendGrid();
      }
    } catch (error) {
      console.error("Failed to fetch department list:", error);
    }
  },
};
</script>

<style scoped>
.d-flex.align-items-center {
  align-items: center;
}

.searchInput {
  text-align: center;
  width: 120px;
  background-color: white !important;
  margin-bottom: 0;
  font-size: 0.8rem;
}

.btn {
  margin-bottom: 0;
}

.card-header, .card-body, .pagination {
  padding: 5px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    align-items: stretch;
  }
  .form-select, .form-control {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .searchInput {
    text-align: left;
  }
}

.table-responsive {
  max-height: 500px;
  overflow-y: auto;
}

.sticky-header th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
}

.sticky-column {
  position: sticky;
  left: 0;
  background-color: white;
}

.grid-container {
  max-height: 90vh;
  overflow-y: auto;
}

.table {
  width: 100%;
  table-layout: fixed;
}

.name-column {
  position: sticky;
  left: 0;
  background-color: white;
  width: 10px;
  text-align: left !important;
  padding-left: 5px !important;
}

.grid-cell {
  padding: 0 !important;
  margin: 0 !important;
}

.date-column {
  width: 10px;
  text-align: center !important;
}

.btn-outline-success {
  color: #c4d14c;
  border-color: #99a148;
  background-color: white;
}

.btn-outline-success:hover {
  color: white;
  background-color: #aadd57;
}
</style>
